import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tagsService } from '../tags.service';
import { BaseCacheService } from './base-cache';
import { userServices } from '../users.service';

@Injectable({
  providedIn: 'root'
})
export class UsersCacheService extends BaseCacheService<any> {
  constructor(private userService: userServices) {
    super();
  }

  protected fetchApiData(): Observable<any[]> {
    return this.userService.get();
  }
}
